import { FaInfoCircle } from "react-icons/fa";

export const HidePriceComp = ({
    locale,
    addOnclassNames,
    pageType,
}: {
    locale: string;
    addOnclassNames?: string;
    pageType?: string;
}) => {
    const defaultClassName = "padding-x-25 padding-y-9 font-size12-sm fontSize14-2xl cursor-pointer bg-black text-white shadow-sm print:hidden";
    return (
        <button
            type="button"
            onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                window.open(`/${locale}/about-us/contact-us?fromproduct=true`);
            }}
            className={`flex items-center !gap-[10px] ${addOnclassNames ?? defaultClassName}`}
        >
            <FaInfoCircle className="text-[50px] md:text-[30px] 3xl:text-[20px]" />
            {!pageType ? (
                <p className="m-[0px] text-left">
                    For more information regarding this product, please <span className="underline">contact us</span>.
                </p>
            ) : (
                <div className="text-left leading-snug">
                    <p className="block md:hidden lg:block xl:block 3xl:hidden m-[0px]">
                        For more information regarding this product, please <span className="underline">contact us</span>.
                    </p>
                    <p className="hidden md:block lg:hidden xl:hidden 3xl:block m-[0px]">
                        For more information regarding this product<br />
                        please <span className="underline">contact us</span>.
                    </p>
                </div>
            )}
        </button>
    );
}
export const isTohidePriceData = ({ locale, isBuilderRange, isGWAInternal, isLoggedInInternalUser }: any) => {
    const isAuLocale = locale === "au";

    /*External User - Webbed Product: Restricted*/
    if (!isLoggedInInternalUser && isGWAInternal) {
        return true;
    }
    /*NZ zone no restrictions*/
    if (!isAuLocale) {
        return false;
    }
    /*External User - OpenProduct - BasisRange : Restricted*/
    if (!isLoggedInInternalUser && !isGWAInternal && isBuilderRange) {
        return true;
    }
    return false;
}
